import ru from '../../public/locales/ru.json';
import en from '../../public/locales/en.json';
import ro from '../../public/locales/ro.json';
import uk from '../../public/locales/uk.json';

let locales = {
	'ru': ru,
	'en': en,
	'uk': uk,
	'ro': ro
};

export default locales;
